var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu-item",
    {
      staticClass: "el-menu-item__custom",
      attrs: { index: _vm.index, route: _vm.route },
    },
    [
      _c(
        "div",
        {
          staticClass: "img-container",
          on: {
            mouseover: function ($event) {
              _vm.hover = true
            },
            mouseleave: function ($event) {
              _vm.hover = false
            },
          },
        },
        [_c("img", { staticClass: "icon", attrs: { src: _vm.computedIcon } })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }